

export enum FilterTypes {
    NONE,
    DISABLED,
    HIGHLIGHTED
}